import axios from 'axios';
import { keycloakInterceptor } from "../auth/keycloakService";

export const apiCand = axios.create({
  baseURL: process.env.REACT_APP_URL_API_CAND,
});
apiCand.interceptors.request.use(keycloakInterceptor);
